module.exports = __webpack_public_path__ + "img/services-portocaliu2.7840d391.svg";